import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../store'
import { useDispatch, useSelector } from 'react-redux'
import {  fetchPopularHalls } from '../../features/admin/placeSlice'
import { useTranslation } from 'react-i18next'
import { Hall, Stay } from '../../types'
import StayCard from '../common/StayCard'
import SwiperCards from '../common/SwiperCards'
import SectionHeader from '../ui/SectionHeader'
import Loading from '../ui/Loading'

const PopularHalls = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { popularHalls, pagination ,loading} = useSelector((state: RootState) => state.placeSlice)
    const { user } = useSelector((state: RootState) => state.user);
    const [localHalls, setLocalHalls] = useState<Hall[]>([])
    useEffect(() => {
        dispatch(fetchPopularHalls({ userId: user?.id, page: 1 }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])
    useEffect(() => {
        if (popularHalls.length) {
            if (pagination?.currentPage === 1) {
                setLocalHalls(popularHalls) // replace
            } else {
                setLocalHalls((prev) => [...prev, ...popularHalls]) // append
            }
        }
    }, [popularHalls, pagination])
    if(popularHalls.length===0) return null;
    if(loading) return <Loading/>
    return (
        <div className='py-5'>
            <div className='padding-container'>
                <SectionHeader title={t("popular-halls")} text={t("popular-halls-subTitle")} />
            </div>

            <div className='mt-8'>
                <SwiperCards
                    currentPage={pagination?.currentPage}
                    lastPage={pagination?.lastPage}
                    onLoadMore={() => {
                        if (pagination ) {
                            dispatch(fetchPopularHalls({ userId: user?.id ?? undefined, page: pagination.currentPage + 1 }));
                        }
                    }}
                >
                    {localHalls.map((stay: Stay, index: number) => (
                        <StayCard key={index} stay={stay} userId={user?.id} />
                    ))}
                </SwiperCards>
            </div>
        </div>
    )
} 

export default PopularHalls